import React from 'react';
import { FileTextIcon, CheckCircleIcon, ClockIcon, AlertTriangleIcon } from 'lucide-react';
import MetricsCard from '../components/MetricsCard';
import ThemeCard from '../components/ThemeCard';
import { overviewMetrics, themes } from '../utils/mockData';
import { colors } from '../utils/colors';
const Overview = () => {
  const getIcon = (index: number) => {
    switch (index) {
      case 0:
        return <FileTextIcon className="h-6 w-6" style={{
          color: colors.primary.dark
        }} data-id="element-177" />;
      case 1:
        return <CheckCircleIcon className="h-6 w-6" style={{
          color: colors.primary.dark
        }} data-id="element-178" />;
      case 2:
        return <ClockIcon className="h-6 w-6" style={{
          color: colors.primary.dark
        }} data-id="element-179" />;
      case 3:
        return <AlertTriangleIcon className="h-6 w-6" style={{
          color: colors.primary.dark
        }} data-id="element-180" />;
      default:
        return <FileTextIcon className="h-6 w-6" style={{
          color: colors.primary.dark
        }} data-id="element-181" />;
    }
  };
  // Get top 3 priority themes
  const priorityThemes = [...themes].sort((a, b) => {
    const priorityOrder = {
      critical: 0,
      high: 1,
      medium: 2,
      low: 3
    };
    return priorityOrder[a.priority] - priorityOrder[b.priority];
  }).slice(0, 3);
  return <div data-id="element-182">
      <div className="mb-6" data-id="element-183">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-184">
          Water Reform Consultation
        </h1>
        <p className="mt-1 text-sm text-gray-600" data-id="element-185">
          Executive summary of submission analysis • Last updated:{' '}
          {new Date().toLocaleDateString()}
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-186">
        {overviewMetrics.map((metric, index) => <MetricsCard key={index} title={metric.title} value={metric.value} change={metric.change} trend={metric.trend as any} icon={getIcon(index)} color={metric.color} data-id="element-187" />)}
      </div>
      <div className="mb-8" data-id="element-188">
        <div className="flex justify-between items-center mb-4" data-id="element-189">
          <h2 className="text-lg font-medium text-gray-900" data-id="element-190">Priority Themes</h2>
          <button className="text-sm font-medium hover:opacity-80" style={{
          color: colors.primary.medium
        }} data-id="element-191">
            View all themes
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-192">
          {priorityThemes.map((theme, index) => <ThemeCard key={index} title={theme.title} count={theme.count} description={theme.description} priority={theme.priority as any} confidence={theme.confidence} treatyRelevant={theme.treatyRelevant} data-id="element-193" />)}
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-5 mb-8" data-id="element-194">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-195">
          Recommended Next Steps
        </h2>
        <div className="space-y-4" data-id="element-196">
          <div className="flex items-start" data-id="element-197">
            <div className="flex-shrink-0 h-5 w-5 rounded-full flex items-center justify-center text-white font-bold" style={{
            backgroundColor: colors.primary.medium
          }} data-id="element-198">
              1
            </div>
            <div className="ml-3" data-id="element-199">
              <h3 className="text-sm font-medium text-gray-900" data-id="element-200">
                Schedule Technical Working Group on Nitrate Standards
              </h3>
              <p className="text-sm text-gray-500" data-id="element-201">
                High priority theme with conflicting evidence
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-202">
            <div className="flex-shrink-0 h-5 w-5 rounded-full flex items-center justify-center text-white font-bold" style={{
            backgroundColor: colors.primary.medium
          }} data-id="element-203">
              2
            </div>
            <div className="ml-3" data-id="element-204">
              <h3 className="text-sm font-medium text-gray-900" data-id="element-205">
                Engage with Iwi Leaders Group on Co-Governance Framework
              </h3>
              <p className="text-sm text-gray-500" data-id="element-206">
                Treaty-relevant submissions require follow-up
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-207">
            <div className="flex-shrink-0 h-5 w-5 rounded-full flex items-center justify-center text-white font-bold" style={{
            backgroundColor: colors.primary.medium
          }} data-id="element-208">
              3
            </div>
            <div className="ml-3" data-id="element-209">
              <h3 className="text-sm font-medium text-gray-900" data-id="element-210">
                Develop Economic Impact Mitigation Options
              </h3>
              <p className="text-sm text-gray-500" data-id="element-211">
                Compromise opportunity between timeline and standards
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-5" data-id="element-212">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-213">
          Key Statistics
        </h2>
        <div className="space-y-4" data-id="element-214">
          <div className="flex justify-between" data-id="element-215">
            <span className="text-sm text-gray-500" data-id="element-216">
              Average confidence score
            </span>
            <span className="text-sm font-medium text-gray-900" data-id="element-217">84%</span>
          </div>
          <div className="flex justify-between" data-id="element-218">
            <span className="text-sm text-gray-500" data-id="element-219">Human review required</span>
            <span className="text-sm font-medium text-gray-900" data-id="element-220">
              78 submissions (6.3%)
            </span>
          </div>
          <div className="flex justify-between" data-id="element-221">
            <span className="text-sm text-gray-500" data-id="element-222">Processing time saved</span>
            <span className="text-sm font-medium text-gray-900" data-id="element-223">
              ~215 person-days
            </span>
          </div>
          <div className="flex justify-between" data-id="element-224">
            <span className="text-sm text-gray-500" data-id="element-225">
              Treaty-relevant submissions
            </span>
            <span className="text-sm font-medium text-gray-900" data-id="element-226">
              127 (10.2%)
            </span>
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-227">
          <button className="w-full py-2 px-4 rounded-md text-white hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2" style={{
          backgroundColor: colors.primary.medium
        }} data-id="element-228">
            Generate Executive Briefing
          </button>
        </div>
      </div>
    </div>;
};
export default Overview;